module.exports = __webpack_public_path__ + "static/media/error-icon.73ddcc51.png";